import type {
  CardsForUserResponse,
  Deposit,
  DepositRefundResponse,
  PaymentsAPIResponse,
  PaymentsCard,
  PaymentsRequest,
  User
} from '@library/types/payments';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';
import { defaultHeaders } from '@bo-constants/apiHeaders';
import { transformPayments } from '@bo-utils/payments';

const { payments } = apiPaths;

export const paymentsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPaymentsTransactions: build.query<
      PaymentsAPIResponse | undefined,
      PaymentsRequest
    >({
      query: ({ email, id, page, perPage }) => ({
        url: `${payments}transactions`,
        method: 'GET',
        params: {
          email,
          id,
          page,
          perPage
        },
        headers: defaultHeaders
      }),

      keepUnusedDataFor: 0,
      transformResponse: (response: PaymentsAPIResponse) => {
        return transformPayments(response);
      },
      providesTags: ['Payments']
    }),
    getCardsForUser: build.query<
      CardsForUserResponse | undefined,
      { user_uuid: User['uuid']; email?: string }
    >({
      query: ({ user_uuid, email }) => ({
        url: `${payments}cards_for_user`,
        method: 'GET',
        headers: defaultHeaders,
        params: { user_uuid, email }
      }),
      keepUnusedDataFor: 0,
      providesTags: ['PaymentMethods']
    }),
    deleteCardForUser: build.mutation<
      object,
      PaymentsCard & { userUuid: User['uuid'] }
    >({
      query: (args) => {
        const { userUuid, card } = args;

        const body = {
          userUUID: userUuid,
          cardDetails: card
        };

        return {
          url: `${payments}delete_card_for_user`,
          method: 'POST',
          body,
          headers: defaultHeaders
        };
      },
      invalidatesTags: ['PaymentMethods']
    }),
    refundPayment: build.mutation<
      DepositRefundResponse,
      { id: Deposit['merchantReferenceId'] }
    >({
      query: (args) => {
        const { id } = args;
        const body = { id };

        return {
          url: `${payments}refund_payment`,
          method: 'POST',
          body,
          headers: defaultHeaders
        };
      }
      // invalidatesTags: ['Payments']
    })
  })
});

export const {
  useDeleteCardForUserMutation,
  useGetCardsForUserQuery,
  useGetPaymentsTransactionsQuery,
  useLazyGetCardsForUserQuery,
  useLazyGetPaymentsTransactionsQuery,
  useRefundPaymentMutation
} = paymentsApi;
